const Menu = [
    {
        id: 1,
        image: "images/maggi.jpg",
        name: "maggi",
        category: "breakfast",
        price: "12₹",
        description:
          "I love Maggi realy oo yues  Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
    
      {
        id: 2,
        image: "images/allupakoida.jpg",
        name: "aloo pakoda",
        category: "evening",
        price: "20₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 3,
        image: "images/corn.jpg",
        name: "corn",
        category: "breakfast",
        price: "10₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 4,
        image: "../images/chola.jpg",
        name: "chhola",
        category: "lunch",
        price: "50₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 5,
        image: "../images/pizza.jpg",
        name: "pizza",
        category: "evening",
        price: "80₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 6,
        image: "../images/nonvegthali.jpg",
        name: "Non-Veg Thali",
        category: "dinner",
        price: "180₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 7,
        image: "../images/sweet.jpg",
        name: "Sweets",
        category: "dinner",
        price: "60₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 8,
        image: "../images/rajmarice.jpg",
        name: "Rajma Rice",
        category: "lunch",
        price: "60₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 9,
        image: "../images/samosa.jpg",
        name: "samosa",
        category: "evening",
        price: "10₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 10,
        image: "../images/iceCream.jpg",
        name: "ice cream",
        category: "dessert",
        price: "40₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 11,
        image: "../images/iceCream2.jpg",
        name: "ice cream",
        category: "dessert",
        price: "60₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 12,
        image: "../images/vegthali.jpg",
        name: "Veg Thali",
        category: "dinner",
        price: "160₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 13,
        image: "../images/momo.jpg",
        name: "momos",
        category: "evening",
        price: "80₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 14,
        image: "../images/puri.jpg",
        name: "Puri sabzi",
        category: "dinner",
        price: "150₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 15,
        image: "../images/rotiwithmeat.jpg",
        name: "Roti & Meat",
        category: "dinner",
        price: "170₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 16,
        image: "../images/paubhaji.jpg",
        name: "Buttery Pav Bhaji",
        category: "lunch",
        price: "100₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
];

export default Menu;